module.exports = __webpack_public_path__ + "img/no-image.51794f38.jpg";